import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export async function updateMacroCategories({ id, categories } = {}) {
    if (!id) return false
    const result = await mutate(
        gql`
            mutation UpdateMacroCategories($id: String!, $categories: [String!]) {
                updateMacroCategories(id: $id, categories: $categories)
            }
        `,
        { id, categories }
    )

    return Boolean(result?.updateMacroCategories)
}
